import {AvatarLibraryItem, SoundLibraryItem} from 'powtoon-library/common/types'
import {BasePlaybackSettings} from 'powtoon-versioning/src/currentSchema'
import lib2AvatarAudioTrack from '../../lib2SoundItem/lib2AvatarAudioTrack'

interface AvatarItemOptions {
  audioTrackToAdd?: SoundLibraryItem,
  additionalPlaybackSettings?: BasePlaybackSettings
}

export default function avatarItem(libraryItem: AvatarLibraryItem, options?: AvatarItemOptions) {
  if (options?.audioTrackToAdd) {
    const audioTrack = lib2AvatarAudioTrack(options.audioTrackToAdd)
    const playbackSettings = {
      ...(options?.additionalPlaybackSettings || {}),
      startTime: options?.additionalPlaybackSettings?.startTime || 0,
      endTime: options?.additionalPlaybackSettings?.endTime ||options.audioTrackToAdd.length
    }

    return {
      audioTracks: [audioTrack],
      playbackSettings
    }
  }
}
